
import ReactionButton from './ReactionButton';

interface LikeButtonProps {
  id: string;
  showModal?: boolean;
}

const LikeButton = ({ id, showModal = false }: LikeButtonProps) => {
  // Use the new ReactionButton component for enhanced functionality
  return <ReactionButton postId={id} showModal={showModal} />;
};

export default LikeButton;
